import { FDealType, FOfferType, isAvailableStrict } from '../../../../../../../packages/JsonQuery';
import { IFilterSet, TAllFilter } from 'shared/types/filters';

const OFFER_TYPE = FOfferType.House;

export const HOUSE_FILTERS_SET: IFilterSet<TAllFilter>[] = [
  {
    availability: isAvailableStrict(FDealType.RentDaily, OFFER_TYPE),
    list: [
      'dealType',
      'objectType',
      'dates',
      'price',
      'onlineBooking',
      'withNeighbors',
      'fromMKAD',
      'undergroundTime',
      'suburbanAreaDailyrent',
      'facilities',
      'livingConditions',
      'suburbanFacilities',
      'bathType',
      'suburbanBathroom',
      'repair',
      'floors',
      'bedrooms',
      'constructionType',
      'heatingType',
      'constructionYear',
      'publicationDate',
      'isOwner',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
];
